import { render } from "./TeacherClassFee.vue?vue&type=template&id=35f15b98&scoped=true"
import script from "./TeacherClassFee.vue?vue&type=script&lang=js"
export * from "./TeacherClassFee.vue?vue&type=script&lang=js"

import "./TeacherClassFee.vue?vue&type=style&index=0&id=35f15b98&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f15b98"]])

export default __exports__